<template>
  <div id="connected-lang" class="container-fluid">
    <p class="success_title">You are now connected to wifi!</p>

    <template v-if="!showForm && !enrolled">
      <p class="success_text">Don't miss out on Brilliant benefits:</p>

      <div class="icon-array">
        <ul class="icon-ul">
          <li>
            <div class="icon-box"><img :src="assets.diningIcon" alt="Dining Discounts"></div>
            <p>Dining Discounts</p>
          </li>
          <li>
            <div class="icon-box"><img :src="assets.ratesIcon" alt="Member Rates"></div>
            <p>Member Rates</p>
          </li>
        </ul>

        <button type="button" class="solid-button" @click="showForm = true">JOIN NOW</button>
        <button type="button" class="close-link" @click="closeInterstitial">Close</button>
      </div>
    </template>

    <template v-else-if="showForm && !enrolled">
      <langham-brilliant-form
        :nseid="connection_data.nseid"
        :mac_address="connection_data.client_mac"
        v-on:enrolled="handleEnrolled"
      />
      <button type="button" class="close-link" @click="closeInterstitial">Close</button>
    </template>

    <template v-else>
      <p class="success_text">Thank you for joining Brilliant by Langham!</p>
      <div class="icon-array enrolled-actions">
        <a href="https://www.brilliantbylangham.com/en" class="solid-button" target="_blank" rel="noopener noreferrer">EXPLORE MORE</a>
        <button type="button" class="close-link" @click="closeInterstitial">Close</button>
      </div>
    </template>

    <div
      v-if="!showForm"
      class="connected-promos"
      :class="{ 'connected-promos--pressreader-only': !qrCode }"
    >
      <div v-if="qrCode" class="connected-promos-qr">
        <img :src="qrCode" alt="QR code">
        <p>
          Scan the QR code to connect with a member of our team!
          <a
            v-if="chatUrl"
            :href="chatUrl"
            class="chat-link"
            target="_blank"
            rel="noopener noreferrer"
          >Chat with us</a>
        </p>
      </div>
      <div class="connected-promos-pressreader">
        <img :src="assets.pressReader" alt="PressReader">
      </div>
    </div>
  </div>
</template>

<script>
import LanghamBrilliantForm from '@/components/custom/_langham2026/LanghamBrilliantForm';
import ratesIcon from '@/components/custom/_langham2026/assets/img/ratesIcon.svg';
import diningIcon from '@/components/custom/_langham2026/assets/img/diningIcon.svg';
import pressReader from '@/components/custom/_langham2026/assets/img/pressreader_en.jpg';

export default {
  name: 'langham-connected',
  components: {
    'langham-brilliant-form': LanghamBrilliantForm,
  },
  props: {
    portal: { type: Object, required: true },
    connection_data: { type: Object, required: true },
    chatUrl: { type: String, default: '' },
    qrCode: { type: String, default: '' },
  },
  data() {
    return {
      showForm: false,
      enrolled: false,
      assets: { ratesIcon, diningIcon, pressReader },
    };
  },
  methods: {
    handleEnrolled() {
      this.enrolled = true;
      this.showForm = false;
    },
    closeInterstitial() {
      const url = this.portal.template.redirect_url;
      if (url) {
        window.location = url;
      }
    },
  },
};
</script>

<style scoped>
#connected-lang {
  color: black;
  width: 72.5%;
  margin: 0 auto;
}

.success_title,
.success_text {
  font-family: serif;
  font-style: normal;
  font-weight: 400;
  font-size: 1.35rem;
  line-height: 1.5rem;
  text-align: center;
  letter-spacing: 1px;
  color: #000000;
}

.success_title {
  margin-top: 20px;
}

.success_text {
  margin: 1.55rem auto 0;
}

.icon-array {
  width: 100%;
  margin: 30px auto;
  padding: 20px 2.5rem;
}

.enrolled-actions {
  padding-top: 10px;
}

.icon-ul {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 0;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  list-style: none;
  padding: 0;
}

.icon-ul > li {
  width: 33.3%;
  text-align: center;
}

.icon-ul > li > .icon-box {
  width: 100px;
  height: 50px;
  margin: auto;
}

.icon-ul > li > .icon-box > img {
  width: 100%;
  height: 100%;
}

.icon-ul > li > p {
  font-family: serif;
  font-size: 1.35rem;
  line-height: 1.5rem;
  text-align: center;
  letter-spacing: 1px;
  color: #000000;
  margin-top: 2.5rem;
}

.solid-button {
  display: block;
  width: 50%;
  padding: 10px 30px;
  font-size: 1rem;
  line-height: 1rem;
  background-color: #58170D;
  letter-spacing: 1px;
  border-radius: 0;
  color: #FFF;
  font-weight: 700;
  text-transform: none;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  margin: 40px auto 20px;
  border: 1px solid #58170D;
  height: auto;
  min-height: 37px;
}

.close-link {
  display: block;
  text-align: center;
  color: #151515;
  margin-bottom: 60px;
  text-decoration: none;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 1rem;
  line-height: 1rem;
  letter-spacing: 1px;
  background: transparent;
  border: none;
  cursor: pointer;
}

.connected-promos {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 80%;
  margin: 0 auto 60px;
  gap: 20px;
}

.connected-promos--pressreader-only {
  justify-content: center;
}

.connected-promos-qr {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
  max-width: 55%;
}

.connected-promos-qr img {
  height: 138px;
  width: auto;
  display: block;
}

.connected-promos-qr p {
  font-size: 1rem;
  line-height: 1.25rem;
  color: #000;
  padding: 10px 0 0;
  margin: 0;
  text-align: left;
}

.chat-link {
  display: block;
  margin-top: 8px;
  color: #58170D;
  font-weight: 700;
}

.connected-promos-pressreader {
  flex-shrink: 0;
}

.connected-promos-pressreader img {
  height: 138px;
  width: auto;
  display: block;
}

@media (max-width: 768px) {
  .icon-ul {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }

  .icon-ul > li {
    width: 100%;
  }

  .solid-button {
    width: 100%;
  }

  .connected-promos {
    flex-direction: column;
    width: 100%;
    padding: 0 25px;
    margin-bottom: 50px;
  }

  .connected-promos-qr {
    max-width: 100%;
  }

  .connected-promos-qr img {
    height: 130px;
  }

  .connected-promos-qr p {
    width: calc(100% - 168px);
    padding: 10px 0 0 15px;
  }

  .connected-promos-pressreader {
    align-self: flex-end;
    margin-top: 25px;
    margin-bottom: 50px;
  }

  .connected-promos--pressreader-only .connected-promos-pressreader {
    align-self: center;
  }
}
</style>
